export const calendarConstants = {
    CALENDAR_FETCHING: 'CALENDAR_FETCHING',
    CALENDAR_FETCHED: 'CALENDAR_FETCHED',
    CALENDAR_SUBMITTING: 'CALENDAR_SUBMITTING',
    CALENDAR_SUBMITTED: 'CALENDAR_SUBMITTED',
    GET_ALL_HOLIDAYS: 'GET_ALL_HOLIDAYS',
    GET_HOLIDAY_BY_ID: 'GET_HOLIDAY_BY_ID',
    GET_ALL_WORKING_DAYS: 'GET_ALL_WORKING_DAYS',
    GET_WORK_DAY_BY_BRANCH: 'GET_WORK_DAY_BY_BRANCH',
    GET_LOCAL_HOLIDAY_BY_BRANCH: 'GET_LOCAL_HOLIDAY_BY_BRANCH',
}